import React from 'react'
import { createComponent } from '@ycos/fela'
import PropTypes from 'prop-types'
import Muted from './icons/muted.svg'
import UnMuted from './icons/unmuted.svg'

const MuteButton = createComponent(
  'MuteButton',
  ({ theme }) => ({
    position: 'absolute',
    top: `${theme.spacingMultiplier}px`,
    right: `${theme.spacingMultiplier}px`,
    cursor: 'pointer',
    padding: `${theme.spacingMultiplier}px`,
    zIndex: '5',
    display: 'flex',
    alignItems: 'flex-end',
    background: 'none',
    border: 'none',
    outlineColor: theme.typography.colors.SecondaryGreySteel,
  }),
  'button',
  ['aria-label', 'onClickCapture']
)

/**
 * Renders Mute/UnMute icons consonant to passed prop
 * @param {Object} props
 * @param {Boolean|undefined} [props.muted] indicates state of video associated with this input
 * @param {Object} [props.CTAs] describes CTAs (optional as a11y uses SVG title as a falback)
 * @param {Object} [props.CTAs.unMuteVideo] CTA when video is muted, and should be unmuted
 * @param {Object} [props.CTAs.muteVideo] CTA when video is unmuted, and should be muted
 * @param {Function} props.onClick function to be called upon interaction
 * @returns
 */
const MuteUnMuteButton = ({ muted, CTAs, onClick }) => (
  <MuteButton onClickCapture={onClick} aria-label={muted ? CTAs?.muteVideo : CTAs?.unMuteVideo}>
    {muted ? <Muted /> : <UnMuted />}
  </MuteButton>
)

MuteUnMuteButton.propTypes = {
  onClick: PropTypes.func,
  muted: PropTypes.bool.isRequired,
  CTAs: PropTypes.shape({
    unMuteVideo: PropTypes.string,
    muteVideo: PropTypes.string,
  }).isRequired,
}

MuteUnMuteButton.defaultProps = {
  CTAs: {
    unMuteVideo: 'unMuteVideo',
    muteVideo: 'muteVideo',
  },
  muted: false,
}

export default MuteUnMuteButton
